import React from 'react';
import DistributionBarCard from './DistributionBarCard';

const ValuableTopicsCard = ({ topics = [] }) => (
  <DistributionBarCard
    title="Most Valuable Topics"
    subtitle="(Q3 – multi-select)"
    icon="☰"
    items={topics}
    columns={2}
    getLabel={(item) => item.topic || item.Topic || '—'}
    getCount={(item) => Number(item.count ?? item.Count ?? 0)}
    getPercentage={(item) => Number(item.percentage ?? item.Percentage ?? 0)}
    getBarClass={() => 'fi-bar-blue'}
    footer={
      topics.length === 0 ? (
        <p className="fi-empty-inline">No topic responses yet.</p>
      ) : null
    }
  />
);

export default ValuableTopicsCard;
